import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=2cb65d1b&"
import script from "./Expenses.vue?vue&type=script&lang=js&"
export * from "./Expenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb65d1b')) {
      api.createRecord('2cb65d1b', component.options)
    } else {
      api.reload('2cb65d1b', component.options)
    }
    module.hot.accept("./Expenses.vue?vue&type=template&id=2cb65d1b&", function () {
      api.rerender('2cb65d1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget/Expenses.vue"
export default component.exports